import { cn } from '@frontdoor/ui/lib/utils';
import { Mail, Phone } from 'lucide-react';

import { SUPPORT_EMAIL, SUPPORT_PHONE_E164 } from '@/lib/constants.ts';

type NeedHelpFooterProps = {
  className?: string;
};

export function NeedHelpFooter({ className }: NeedHelpFooterProps) {
  return (
    <section className={cn('mb-8 pt-10 pb-8', className)}>
      <h2 className="font-serif text-xl leading-tight">Need help?</h2>
      <p className="mt-3 text-sm text-muted-foreground">Contact our support team</p>
      <div className="mt-5 grid grid-cols-2 gap-3 md:grid-cols-1 lg:grid-cols-2">
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          className="flex flex-col items-center gap-3 rounded-xl border border-border bg-card px-4 py-5 text-sm transition-colors hover:bg-muted"
        >
          <Mail className="size-8 text-muted-foreground" />
          <span>Email Us</span>
        </a>
        <a
          href={`tel:${SUPPORT_PHONE_E164}`}
          className="flex flex-col items-center gap-3 rounded-xl border border-border bg-card px-4 py-5 text-sm transition-colors hover:bg-muted"
        >
          <Phone className="size-8 text-muted-foreground" />
          <span>Call Us</span>
        </a>
      </div>
    </section>
  );
}
